// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MSnYz","information":"styles_information__JOvHI","field":"styles_field__J4lCk"};